import * as React from "react";
const SvgBug20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm3.57 1.55a3 3 0 1 0-5.14 0c-1.07.48-2 1.251-2.726 2.217L2.223 5.113l-1.11 1.664 2.592 1.728A8.884 8.884 0 0 0 3.055 11H.5v2h2.555c.08.73.249 1.435.493 2.1l-2.435 1.623 1.11 1.664 2.24-1.493C5.718 18.76 7.691 20 10 20s4.28-1.24 5.538-3.106l2.24 1.493 1.109-1.664-2.435-1.624c.244-.664.412-1.37.493-2.099H19.5v-2h-2.555a8.883 8.883 0 0 0-.65-2.495l2.592-1.728-1.11-1.664-2.48 1.654C14.57 5.801 13.64 5.03 12.57 4.55ZM5 12c0-3.016 1.803-5.329 4-5.876v11.752C6.803 17.33 5 15.016 5 12Zm10 0c0 3.016-1.803 5.329-4 5.876V6.124c2.197.547 4 2.86 4 5.876Z",
      clipRule: "evenodd"
    })
  );
export default SvgBug20Px;
